<div @containerFade class="portfolio-spinner">
  <div class="portfolio-spinner-container">
    <div class="portfolio-spinner-logo" @elementFade *ngIf="activeStep !== spinnerSteps.FINISH">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M26 25.9675V0H0C0 14.365 11.635 26 26 25.9675L0 26V52C14.365 52 26 40.365 26 25.9675L52 26V0C37.6675 0 26.0325 11.6025 26 25.9675Z"
          fill="#EE3C15"
        />
      </svg>
    </div>
    <div class="portfolio-spinner-content">
      <div class="portfolio-spinner-step">
        <h2 [@textFade]="toggleAnimation(spinnerSteps.START)" class="ui-headline">
          {{ 'loadPortfolio.spinner.1.title' | translate }}
        </h2>
        <p [@textFade]="toggleAnimation(spinnerSteps.START)">{{ 'loadPortfolio.spinner.1.p1' | translate }}</p>
      </div>

      <div class="portfolio-spinner-step">
        <h2 [@textFade]="toggleAnimation(spinnerSteps.DISLIKE)" class="ui-headline">
          {{ 'loadPortfolio.spinner.2.title' | translate }}
        </h2>
        <p [@textSlideExit]="toggleAnimation(spinnerSteps.DISLIKE)">
          {{ 'loadPortfolio.spinner.2.p1' | translate }} <span class="icon-i-blocked"></span>
        </p>
        <p [@textFade]="toggleAnimation(spinnerSteps.DISLIKE)">{{ 'loadPortfolio.spinner.2.p2' | translate }}</p>
      </div>

      <div class="portfolio-spinner-step">
        <h2 [@textFade]="toggleAnimation(spinnerSteps.LIKE)" class="ui-headline">
          {{ 'loadPortfolio.spinner.3.title' | translate }}
        </h2>
        <p [@textSlideEnter]="toggleAnimation(spinnerSteps.LIKE)">
          {{ 'loadPortfolio.spinner.3.p1' | translate }} <span class="icon-i-heart"></span>
        </p>
        <p [@textFade]="toggleAnimation(spinnerSteps.LIKE)">{{ 'loadPortfolio.spinner.3.p2' | translate }}</p>
      </div>

      <div class="portfolio-spinner-step">
        <h2 [@textFade]="toggleAnimation(spinnerSteps.FINISH)" class="ui-headline">
          {{ 'loadPortfolio.spinner.4.title' | translate }}
        </h2>
        <p
          [@textSlideEnter]="toggleAnimation(spinnerSteps.FINISH)"
          [innerHTML]="'loadPortfolio.spinner.4.p1' | translate: { numberOfCompanies: numberOfCompanies }"
        ></p>
        <button
          @elementFade
          *ngIf="activeStep === spinnerSteps.FINISH"
          type="button"
          class="ui-button full-width"
          (click)="onCloseLoader()"
        >
          {{ 'loadPortfolio.spinner.4.CTA' | translate }}
        </button>
        <p
          class="portfolio-spinner-redirection"
          [@textFade]="toggleAnimation(spinnerSteps.FINISH)"
          [innerHTML]="'loadPortfolio.spinner.4.redirect' | translate: { seconds: seconds }"
        ></p>
      </div>
    </div>
  </div>
  <div class="portfolio-spinner-companies">
    <div class="portfolio-spinner-logos">
      <ng-container *ngFor="let companyLogo of companyLogos">
        <div class="portfolio-spinner-company">
          <img [src]="'assets/images/logos/' + companyLogo + '.png'" [alt]="companyLogo + ' logo'" />
        </div>
      </ng-container>
    </div>
    <p class="portfolio-spinner-disclaimer">{{ 'loadPortfolio.spinner.disclaimer' | translate }}</p>
  </div>
</div>
